export default __webpack_public_path__ + "static/media/123.97846421.png";